import context from "../../../_app/context";
import {redirect} from "react-router-dom";

export const authLayoutLoader = async (params) => {
    if(context.user())  {
        return redirect(context.route("users.Profile"));
    }
    return null;
}
